import React, { memo } from 'react';
import { useStyles } from './PassEopModal.styles';
import { RockyButton } from '@shared/components/RockyButton';
import { Dialog, DialogTitle, IconButton } from '@mui/material';
import partnershipImg from '@assets/img/partnership.png';
import CloseIcon from '@mui/icons-material/Close';
import { getEvaluationTerms } from '@shared/helpers/evaluationTerminology';

interface Props {
  evaluationId: string;
  closeModal: () => void;
  isModalOpen: boolean;
  handleSubmit: (evaluationId: string) => void;
  officeCountry?: string;
  userName: string;
}

const PassEopModalComponent: React.FC<Props> = ({
  evaluationId,
  closeModal,
  isModalOpen,
  handleSubmit,
  officeCountry,
  userName,
}) => {
  const styles = useStyles();
  const evaluationTerms = getEvaluationTerms(officeCountry);

  const onConfirm = () => {
    handleSubmit(evaluationId);
    closeModal();
  };

  return (
    <Dialog fullWidth open={isModalOpen}>
      <IconButton aria-label="close" onClick={closeModal} className={styles.goalDialogClose}>
        <CloseIcon />
      </IconButton>
      <div className={styles.dialogRoot}>
        <img src={partnershipImg} className={styles.ufoImg} />
        <DialogTitle className={styles.dialogTitle}>{evaluationTerms.periodPassingTitle}</DialogTitle>
        <div className={styles.dialogDescription}>
          {evaluationTerms.accountingPassedNote.replace('{name}', userName)}
        </div>
        <div className={styles.buttonsRow}>
          <RockyButton action type="submit" className={styles.submitButton} onClick={onConfirm}>
            Confirm
          </RockyButton>
          <RockyButton className={styles.button} onClick={closeModal}>
            Cancel
          </RockyButton>
        </div>
      </div>
    </Dialog>
  );
};

export const PassEopModal = memo(PassEopModalComponent);
